import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DeployInstanceFormComponent } from 'src/app/main/service/deploy-instance-form/deploy-instance-form.component';
import { Deployment } from 'src/app/models/deploy/deployment';
import { Solution } from 'src/app/models/service/solution';
import { FormUtilService } from 'src/app/services/util/form-util.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';

@Component({
    selector: 'app-request-deploy-instance-dialog',
    templateUrl: './request-deploy-instance-dialog.component.html',
    styleUrls: ['./request-deploy-instance-dialog.component.scss'],
    standalone: false
})
export class RequestDeployInstanceDialogComponent implements OnInit {

  @ViewChild('deployInstanceForm', { static: false }) public deployInstanceForm: DeployInstanceFormComponent;

  @Input() title: string;
  @Input() subtitle: string;
  @Input() deployment: Deployment;
  @Input() service: Solution;

  requestForm: FormGroup;

  constructor(private formBuilder: FormBuilder, public sidenavService: SidenavService) { }

  ngOnInit(): void {
    this.createRequestForm();
  }

  requestDeployment(): void {
    const newDeployment = this.deployInstanceForm.getDeployment();
    const requestFormValid = FormUtilService.validateForm(this.requestForm);
    if (newDeployment && requestFormValid) {
      const requestFormValue = this.requestForm.getRawValue();
      const result = {
        deployment: newDeployment,
        requestDescription: requestFormValue.requestDescription
      };
      this.sidenavService.closeRightSidenav(result);
    }
  }

  private createRequestForm(): void {
    this.requestForm = this.formBuilder.group({
      requestDescription: ['', Validators.required]
    });
  }
}
